import React from 'react';

function Layouts() {
  return (
    <section className="tc-layouts">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h2 className="fsz-45 fw-600 mb-30">
                Premium Decor <br /> Ranges
              </h2>
              <div className="text fsz-16 mb-30 color-666">
                Authorized Distributor of Delby — Offering a premium collection of
                high-quality PVC, WPC, and designer wallpapers to transform
                your space with elegance and durability.
              </div>
              <div className="icon-cards">
                <div className="item">
                  <div className="icon">
                    <img src="/home_preview/assets/img/l1.png" alt="" loading="lazy" decoding="async" />
                  </div>
                  <p className="fsz-11"> PVC Wall Panels </p>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src="/home_preview/assets/img/l2.png" alt="" loading="lazy" decoding="async" />
                  </div>
                  <p className="fsz-11"> WPC Louvers </p>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src="/home_preview/assets/img/l3.png" alt="" loading="lazy" decoding="async" />
                  </div>
                  <p className="fsz-11"> Charcoal Panels </p>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src="/home_preview/assets/img/l4.png" alt="" loading="lazy" decoding="async" />
                  </div>
                  <p className="fsz-11"> Designer Wallpaper </p>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src="/home_preview/assets/img/l5.png" alt="" loading="lazy" decoding="async" />
                  </div>
                  <p className="fsz-11"> Acoustic Solution </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div
              className="img wow zoomIn slow mt-5 mt-lg-0"
              data-wow-delay="0.4s"
            >
              <img src="/home_preview/assets/img/layout.png" alt="" loading="lazy" decoding="async" />
              <img
                src="/home_preview/assets/img/layout1.png"
                alt=""
                className="sub-img img-contain"
                data-speed="1.2"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
      <img
        src="/home_preview/assets/img/circle.png"
        alt=""
        className="circle rotate-center"
        loading="lazy"
        decoding="async"
      />
    </section>
  );
}

export default Layouts;
